import { useAccess } from "../context/AccessContext";
import { clearAuthCaches } from "../utils/authCache";

export function clearRBACCache() {
  clearAuthCaches();
}

/**
 * Compatibility hook over AccessContext.
 * Post-login permissions are loaded once via GET /api/user/me.
 */
export default function useRBAC() {
  const { permissions, hasAccess, isAdmin, loading } = useAccess();

  return {
    permissions,
    hasAccess,
    isAdmin,
    loading,
  };
}
